<form [formGroup]="registerForm()" class="container">
  <div class="row">
    <div class="col-12">
      <kendo-formfield>
        <kendo-label class="!k-align-items-start" text="Vorname" for="firstName"></kendo-label>
        <kendo-textbox
          showErrorIcon="initial"
          id="firstName"
          [formControlName]="formControlNames.FirstName"
          #firstName
        />
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label class="!k-align-items-start" text="Nachname" for="lastName"></kendo-label>
        <kendo-textbox
          showErrorIcon="initial"
          id="lastName"
          [formControlName]="formControlNames.LastName"
          #lastName
        />
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label class="!k-align-items-start" text="Email" for="email"></kendo-label>
        <kendo-textbox
          showErrorIcon="initial"
          id="email"
          [formControlName]="formControlNames.Email"
          #emailRepeat
        />
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label class="!k-align-items-start" text="Password" for="password"></kendo-label>
        <kendo-textbox
          [type]="'password'"
          showErrorIcon="initial"
          id="password"
          [formControlName]="formControlNames.Password"
          #password
        />
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label
          class="!k-align-items-start"
          text="Passwort Wiederholung"
          for="passwordRepeat"
        ></kendo-label>
        <kendo-textbox
          [type]="'password'"
          showErrorIcon="initial"
          id="passwordRepeat"
          [formControlName]="formControlNames.PasswordRepeat"
          #passwordRepeat
        />
      </kendo-formfield>

      <div style="color: red">
        @if (
          registerForm()?.get("passwordRepeat")?.touched &&
          registerForm()?.get("passwordRepeat")?.hasError("mustMatch")
        ) {
          <div>Passwords must match.</div>
        }

        @if (registerForm()?.get("password")?.hasError("minlength")) {
          <div>Password must be at least 8 characters long.</div>
        }
      </div>

      <div>
        <input type="checkbox" #consent kendoCheckBox />
        <kendo-label class="k-checkbox-label" [for]="consent" text="Ich akzeptiere die AGBs.">
        </kendo-label>
      </div>
    </div>
  </div>
</form>

<div class="container small-font k-mt-5">
  <div class="row k-mt-5">
    <div class="col">
      <button kendoButton themeColor="base" type="submit" size="large" (click)="register()">
        Registrieren
      </button>
    </div>
  </div>
</div>
